export default "__VITE_ASSET__qqYXHbm6__"